import { useContext } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';
import { MarkNotificationAsReadRequestUserTypeEnum } from '../client-sdk/api';

export const useAllMarkReadApi = () => {
  const api = useContext(HimmaContext)!;

  const getAllMarkRead = useCallback(
    async (query: { userId: string; userType: string; isRead: boolean }) => {
      const markNotificationAsReadRequest = {
       userId: query.userId,
        userType :query.userType as MarkNotificationAsReadRequestUserTypeEnum,
        isRead: true
      }
      const response = await api.markNotificationAsRead(markNotificationAsReadRequest);
      return response.data;
    },
    [api]
  );

  return { getAllMarkRead };
};